export enum mixpanelEventTypes {
  REPLENISHMENT_COMPLETE = 'Complete Replenishment',
  REPLENISHMENT_CREATE = 'Create Replenishment',
  REPLENISHMENT_REJECT = 'Reject Replenishment',
  REPLENISHMENT_SEARCH = 'Search Replenishment',
  SIDEBAR_ADD_FAVORTIE = 'Add Favorite',
  SIDEBAR_COLLAPSE = 'Collapse Categories',
  SIDEBAR_EXPAND = 'Expand Categories',
  SIDEBAR_NAVIGATE = 'Navigate',
  USER_LOGIN = 'Login',
  USER_LOGOUT = 'Logout',
  USER_REGISTERED = 'New User Registered',
}
